export enum SceneKeys {
    PRELOADER = "PRELOADER",
    GAME = "GAME",
    SCENE1 = "SCENE1",
    SCENE2="SCENE2",
    UIScene="UIScene",
    WORLD1="WORLD1",
    WORLD2="WORLD2",
    WORLD3="WORLD3",
    WORLD4="WORLD4",
    WORLD5="WORLD5",
    Menu="Menu",
    Help="Help",
}